import React from "react";
import Header from "../layout/Header";

const Empty = () => {
  return (
    <div>
      <Header />
    </div>
  );
};

export default Empty;
